import * as React from 'react';
import type { SVGProps } from 'react';
const SvgNeutralEmotion = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
    <circle cx={10} cy={10} r={10} fill="#FFB03D" />
    <path
      fill="#00265D"
      stroke="#00265D"
      strokeWidth={0.043}
      d="M14.096 8.235c0 .64-.482 1.155-1.073 1.155-.592 0-1.074-.516-1.074-1.155 0-.64.482-1.155 1.074-1.155.591 0 1.073.516 1.073 1.155Zm-5.75 0c0 .64-.482 1.155-1.074 1.155s-1.074-.516-1.074-1.155c0-.64.482-1.155 1.074-1.155s1.074.516 1.074 1.155Z"
    />
    <path stroke="#00265D" strokeLinecap="round" strokeWidth={1.176} d="M5.531 13.672h9.412" />
  </svg>
);
export default SvgNeutralEmotion;
